import { FaLanguage, FaLaptopCode, FaGraduationCap, FaChalkboardTeacher, FaUserClock } from "react-icons/fa";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import './CoachingPage.css';
import IELTS from './images/couching/ielts.jpg'
import toefl from './images/couching/toefl.jpg'
import end from './images/couching/eng.jpg'
import pte from './images/couching/pte.jpeg'
import gre from './images/couching/gre.jpg'
import per from './images/couching/per.jpg'
import inter from './images/couching/inter.avif'

const coachingPrograms = [
  {
    icon: <FaLanguage />,
    title: "IELTS Coaching",
    text: "Enhance your English language skills and confidently clear the IELTS exam with our personalized coaching.",
    imgUrl: IELTS ,
  },
  {
    icon: <FaLanguage />,
    title: "TOEFL Training",
    text: "Get prepared for TOEFL with rigorous practice sessions and expert guidance tailored for university admissions.",
    imgUrl: toefl,
  },
  {
    icon: <FaLanguage />,
    title: "Duolingo English Test",
    text: "Master the Duolingo English Test and improve your proficiency through interactive learning modules.",
    imgUrl: end,
  },
  {
    icon: <FaLanguage />,
    title: "PTE Preparation",
    text: "Achieve top scores in the Pearson Test of English through structured lessons and mock tests.",
    imgUrl: pte,
  },
  {
    icon: <FaLaptopCode />,
    title: "GRE Coaching",
    text: "Sharpen your analytical, verbal, and quantitative skills to excel in the GRE and secure top university placements.",
    imgUrl: gre,
  },
  {
    icon: <FaGraduationCap />,
    title: "Spoken English & Personality",
    text: "Boost your confidence, communication, and personality for academic and career success.",
    imgUrl: per,
  },
  {
    icon: <FaChalkboardTeacher />,
    title: "Interview Preparation",
    text: "Prepare for university and visa interviews with expert tips, mock sessions, and feedback.",
    imgUrl: inter,
  },
  {
    icon: <FaUserClock />,
    title: "Flexible Weekend Batches",
    text: "Weekend coaching sessions available for working professionals and busy students.",
    imgUrl: "https://images.unsplash.com/photo-1607746882042-944635dfe10e?auto=format&fit=crop&w=800&q=60",
  },
];

const CoachingPage = () => {
  return (
    <section className="coaching">
      <div className="coaching-header">
        <h2>Our Coaching Programs</h2>
        <p>Expert-led training programs to help you excel in language tests and build your professional confidence.</p>
      </div>
      <div className="coaching-container">
        {coachingPrograms.map((program, index) => (
          <motion.div
            className="coaching-card"
            key={index}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            viewport={{ once: true }}
          >
            <div className="image-container">
              <img src={program.imgUrl} alt={program.title} className="coaching-image" />
            </div>
            <div className="coaching-content">
              <div className="coaching-icon">{program.icon}</div>
              <h3>{program.title}</h3>
              <p>{program.text}</p>
              <Link to="/form" className="info-link">Enroll Now</Link>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default CoachingPage;
